import { render, staticRenderFns } from "./tfjl.vue?vue&type=template&id=2b0f6dd4&"
import script from "./tfjl.vue?vue&type=script&lang=js&"
export * from "./tfjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports